import React from 'react';

import { photoThumbnailAccessor } from './DayInfoGraph';
import { idOrTimeKey } from '../utils/dataUtils';
import './Dashboard.css';

const debug = (process.env.NODE_ENV !== 'production') && false;

function NutritionPhotos(props) {
  const {
    photos
  } = props;

  if (debug) {
    console.log('Nutrition photos', photos);
  }

  return (
    <div>
      {photos.map(p => <div key={idOrTimeKey(p)} className="nutrition photo" title="Time here">
        <img src={photoThumbnailAccessor(p)} alt=""/>
      </div>)}
    </div>
  );
}


export default NutritionPhotos;
